const reviewRangeSchema = {
  type: 'object',
  properties: {
    from: { type: 'number' },
    to: { type: 'number' },
  },
  required: ['from', 'to'],
} as const;

export const pendingReviewSchemaProperty = {
  type: ['object', 'null'],
  properties: {
    originalDocJson: {
      type: 'object',
      additionalProperties: true,
    },
    reviewDocJson: {
      type: 'object',
      additionalProperties: true,
    },
    suggestions: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          id: { type: 'string' },
          range: reviewRangeSchema,
          rangeInOtherDoc: reviewRangeSchema,
          replacementOptions: {
            type: 'array',
            items: {
              type: 'object',
              properties: {
                id: { type: 'string' },
                content: {
                  oneOf: [
                    {
                      type: 'string',
                    },
                    {
                      type: 'object',
                      additionalProperties: true,
                    },
                    {
                      type: 'null',
                    },
                  ],
                },
                metadata: {
                  type: 'object',
                  additionalProperties: true,
                },
              },
              required: ['id', 'content'],
            },
          },
          metadata: {
            type: 'object',
            additionalProperties: true,
          },
          displayOptions: {
            type: 'object',
            properties: {
              showReplacement: { type: 'boolean' },
              hideCurrentContent: { type: 'boolean' },
              showSubChanges: { type: 'boolean' },
              attributes: {
                type: 'object',
                additionalProperties: true,
              },
              replacementAttributes: {
                type: 'object',
                additionalProperties: true,
              },
              subChangeAttributes: {
                type: 'object',
                additionalProperties: true,
              },
              replacementSubChangeAttributes: {
                type: 'object',
                additionalProperties: true,
              },
            },
          },
          reviewMode: { type: 'string' },
          isInlineGroup: { type: 'boolean' },
        },
        required: ['id', 'range', 'replacementOptions'],
      },
    },
    acceptedCount: { type: 'number' },
    totalCount: { type: 'number' },
    createdAtMs: { type: 'number' },
  },
  required: ['originalDocJson', 'reviewDocJson', 'suggestions'],
  default: null,
} as const;
